import type { Permissions } from 'api/types';
import { hasRequiredPermission } from 'shared/lib/auth/hasRequiredPermission';

import type { Item } from '../types';

export const isItemHidden = (item: Item, permissions: Permissions) =>
  item?.hide || !hasRequiredPermission({ userPermissions: permissions, requiredPermissions: item.permission });
